import { render, staticRenderFns } from "./tax_incentives.vue?vue&type=template&id=3168b1ac&scoped=true&"
import script from "./tax_incentives.vue?vue&type=script&lang=js&"
export * from "./tax_incentives.vue?vue&type=script&lang=js&"
import style0 from "./tax_incentives.vue?vue&type=style&index=0&id=3168b1ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168b1ac",
  null
  
)

export default component.exports